import {
  formatDecorTechIntoOption,
  getDecorTechs,
} from "../../../helpers/decor-tech.helper";
import { PrintingTechniqueActions } from "../state/printingTechnique/create";
import { CreatePrintingTechniqueTypes } from "../state/printingTechnique/create/data";
import { Predicates } from "../../../libraries/predicates/predicates";
import OptionFormatter from "../../../components/OptionFormatter";
import Select from "react-select";
import { useDecorationTechContext } from "../../../context/DecorationTechContext";
import { IDecorationTech, IMold } from "../../../types/data.interface";
import { getMolds } from "../../../helpers/mold.helper";


interface IDecorationTechniqueAsyncSelectProps{
  onChanged: (...args:any[]) => void,
  value?: IDecorationTech,
  isDisabled?:boolean,
  isMandatory?: boolean,

}

export const DecorationTechniqueAsyncSelect = ({isDisabled=false, isMandatory=false, onChanged, value}:IDecorationTechniqueAsyncSelectProps) => {
  const { data: decorationTechs, isLoading: isDecoTechsLoading } =
    useDecorationTechContext();

  const handleUpdateMolds = (e:any) => {
    onChanged(e ? e.value : null)
  }

  return(<>
    <label className="form-label">
      Decoration Technique {isMandatory &&
      <span className="red-text fw-bold">*</span>}
    </label>
    <Select
      options={getDecorTechs(
        decorationTechs.slice(1, decorationTechs.length),
      )}
      onChange={handleUpdateMolds}
      value={
        Predicates.isNotNullAndNotUndefined(
          value,
        )
          ? formatDecorTechIntoOption(value)
          : null
      }
      // value={!!value ? formatDecorTechIntoOption(value): null}
      placeholder=""
      formatOptionLabel={OptionFormatter}
      classNamePrefix="react-select"
      isLoading={isDecoTechsLoading}
      isClearable
      components={{
        IndicatorSeparator: () => null,
      }}
      isDisabled={isDisabled}
    /></>)
}